module.exports = __webpack_public_path__ + "static/media/donation2.8db27376.png";